<template>
  <v-app>
    <template v-if="isAuthenticated">
      <v-app-bar app color="white" light :elevation="1" v-if="isAuthenticated">
        <div class="d-flex align-center ml-10">
          <v-img
            alt="Logo"
            class="shrink ml-4 mr-2"
            contain
            src="@/assets/logo.png"
            transition="scale-transition"
            width="50"
          />
        </div>

        <v-spacer></v-spacer>
        <div class="search-wrapper">
          <div class="search-bar">
            <div class="icon">
              <v-icon>mdi-magnify</v-icon>
            </div>
            <input
              type="text"
              class="search"
              placeholder="Search By Employee, Project..."
            />
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="links">
          <v-btn icon fab x-small @click="logout">
            <v-icon>mdi-power</v-icon>
          </v-btn>
        </div>
        <div class="links mr-5">
          <v-btn icon fab x-small>
            <v-badge color="green" content="6">
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </div>

        <div class="user-info mr-4">
          <v-avatar size="36">
            <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
          </v-avatar>
          <span class="ml-2 mt-1 body-2">{{ userName }}</span>
        </div>
      </v-app-bar>

      <v-content v-if="isAuthenticated">
        <div class="page-wrapper d-flex flex-row">
          <div class="sidebar-wrapper">
            <div class="sidebar">
              <v-navigation-drawer
                drawer
                color="white"
                absolute
                permanent
                light
              >
                <v-list dense nav class="py-0">
                  <v-list-item two-line class="px-0">
                    <v-dialog v-model="dialog" width="500">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          depressed
                          dark
                          large
                          color="#0e07b5"
                          width="90%"
                          class="ma-3"
                          v-on="on"
                        >
                          <v-icon>mdi-plus</v-icon>Add New
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                          >Header Title</v-card-title
                        >
                        <v-card-text>Body Contect</v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="default" text @click="dialog = false"
                            >Cancel</v-btn
                          >
                          <v-btn color="primary" text @click="dialog = false"
                            >Ok</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-list-item>

                  <v-divider class="mb-2"></v-divider>

                  <v-list-item
                    v-for="item in items"
                    :key="item.title"
                    link
                    :class="item.title == activeTab ? 'active' : ''"
                    @click="navigate(item)"
                  >
                    <v-list-item-icon>
                      <v-icon
                        :class="item.title == activeTab ? 'active-link' : ''"
                        >{{ item.icon }}</v-icon
                      >
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>
                        <span
                          :class="item.title == activeTab ? 'active-link' : ''"
                          >{{ item.title }}</span
                        >
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </div>
          </div>

          <div class="page-content">
            <router-view></router-view>
          </div>
        </div>
      </v-content>
    </template>
    <div class="cover-page" v-else>
      <login :authStatus="authStatus"></login>
    </div>
  </v-app>
</template>

<script>
import firebase from "./firebase.js";
import Login from "./pages/Login.vue";
export default {
  name: "App",
  components: {
    Login
  },
  data: () => ({
    userName: "Jane Smith",
    activeTab: "Dashboard",
    dialog: false,
    items: [
      { title: "Dashboard", icon: "mdi-view-dashboard", tab: "Dashboard" },
      { title: "Projects", icon: "mdi-star-outline", tab: "Projects" },
      { title: "Timesheet Requests", icon: "mdi-timetable", tab: "Timesheet" },
      {
        title: "Employees",
        icon: "mdi-account-multiple-outline",
        tab: "Employees"
      },
      { title: "Clients", icon: "mdi-account-outline", tab: "Clients" },
      { title: "Utilization", icon: "mdi-texture", tab: "Utilization" },
      { title: "Reports", icon: "mdi-file-outline", tab: "Reports" },
      { title: "Expense", icon: "mdi-currency-usd", tab: "Expense" }
    ],
    isAuthenticated: false,
    authStatus: ""
  }),

  created() {
    let temp = localStorage.getItem("isAuthenticated");
    if (temp == "true") {
      this.isAuthenticated = true;
    } else this.isAuthenticated = false;

    firebase.auth().onAuthStateChanged((userObj) => {
      if (userObj) {
        this.authStatus = "processing";
        firebase
          .firestore()
          .collection("user")
          .doc(userObj.uid)
          .get()
          .then((user) => {
            if (user.exists) {
              let userData = user.data();
              firebase
                .firestore()
                .collection("dropdowns")
                .doc("roles")
                .get()
                .then((res) => {
                  if (res.exists) {
                    let found = res
                      .data()
                      .allowedUsers.find(
                        (role) =>
                          role.toLowerCase() == userData.role.toLowerCase()
                      );
                    if (found) {
                      this.authStatus = "login";
                      let temp = localStorage.getItem("isAuthenticated");
                      if (!(temp && this.isAuthenticated)) {
                        localStorage.setItem("isAuthenticated", true);
                        this.isAuthenticated = true;
                        this.$router.push({
                          name: "Dashboard"
                        });
                      }
                    } else {
                      this.authStatus = "rejected";
                      this.isAuthenticated = false;
                      localStorage.setItem("isAuthenticated", false);
                    }
                  } else {
                    this.authStatus = "rejected";
                    this.isAuthenticated = false;
                    localStorage.setItem("isAuthenticated", false);
                  }
                })
                .catch((error) => {
                  localStorage.setItem("isAuthenticated", false);
                  console.error(error);
                });
            } else {
              localStorage.setItem("isAuthenticated", false);
              this.isAuthenticated = false;
              this.authStatus = "rejected";
            }
          });
      } else {
        this.authStatus = "logout";
        localStorage.setItem("isAuthenticated", false);
        this.isAuthenticated = false;
        this.$router.push({
          name: "Default"
        });
      }
    });
  },

  methods: {
    navigate(item) {
      this.activeTab = item.title;
      this.$router.push({
        name: item.tab
      });
    },
    logout() {
      localStorage.setItem("isAuthenticated", false);
      this.isAuthenticated = false;
      firebase.auth().signOut();
    }
  }
};
</script>

<style scoped>
.cover-page {
  position: fixed;
  left: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
  overflow: auto;
}
.user-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.page-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.sidebar-wrapper {
  width: 250px;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.sidebar {
  position: fixed;
  height: 100%;
  width: 250px;
}

.page-content {
  flex: 1;
  width: 10%;
  height: 100%;
  background: #fbfaff;
}

.active {
  background: linear-gradient(to right, #f0f3f8, transparent);
  border-left: 4px solid #0e07b5;
  color: #0e07b5;
}

.active-link {
  color: #0e07b5;
}

.search-wrapper {
  width: 50%;
  color: 5c5b60;
  box-sizing: border-box;
}

.search-bar {
  background: #fbfaff;
  margin: 3px 1vw;
  border-radius: 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 25px;
  box-shadow: 0 2px 2px -1px #2222;
}

.search {
  background: #fbfaff;
  border: none;
  font-size: 15px;
  padding: 5px 15px;
  flex: 1;
  outline: none;
}
</style>
